<script>
  import { pop, link } from "svelte-spa-router";
  import active from "svelte-spa-router/active";

  /**
   * retour arriere (history)
   */
  const back = () => {
    pop();
  };
</script>

<div class="fixed-top navbar-dark bg-dark">
  <ul class="nav">
    <li class="nav-item">
      <a
        class="nav-link active"
        aria-current="page"
        href="/"
        use:link
        use:active={{ path: "/", className: "active" }}>Accueil</a
      >
    </li>
    <!-- ============ . APPT ============== -->
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="/#"
        role="button"
        aria-expanded="false">Appt</a
      >
      <div class="dropdown-menu">
        <a
          class="nav-link"
          href="/recap"
          use:link
          use:active={{ path: "/recap/" }}>Recap</a
        >
        <a
          class="nav-link"
          href="/listeappt"
          use:link
          use:active={{ path: "/listeappt/" }}>liste</a
        >
        <a
          class="nav-link"
          href="/loyers"
          use:link
          use:active={{ path: "/loyers/" }}>loyers.</a
        >
        <a
          class="nav-link"
          href="/emprunt"
          use:link
          use:active={{ path: "/emprunt/" }}>emprunts</a
        >
        <hr class="dropdown-divider" />
        <a
          class="nav-link"
          href="/carsdetail"
          use:link
          use:active={{ path: "/carsdetail/" }}>cars détail</a
        >
        <a
          class="nav-link"
          href="/depenses"
          use:link
          use:active={{ path: "/depenses/" }}>Dépenses</a
        >
        <a
          class="nav-link"
          href="/graphdepenses"
          use:link
          use:active={{ path: "/graphdepenses/" }}>Graph Dépenses</a
        >
      </div>
    </li>

    <!-- ============ . OPVCM ============== -->

    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="/#"
        role="button"
        aria-expanded="false">Opvcm</a
      >
      <div class="dropdown-menu">
        <a
          class="nav-link"
          href="/listebybk"
          use:link
          use:active={{ path: "/listebybk/" }}>liste Bk</a
        >
        <a
          class="nav-link"
          href="/listeopvcm"
          use:link
          use:active={{ path: "/listeopvcm/" }}>liste</a
        >
        <a
          class="nav-link"
          href="/listetabopvcm"
          use:link
          use:active={{ path: "/listetabopvcm/" }}>liste tableau</a
        >
        <a
          class="nav-link"
          href="/grapheopvcm"
          use:link
          use:active={{ path: "/grapheopvcm/" }}>Graphe bulles</a
        >
        <a
          class="nav-link"
          href="/brickssynthese"
          use:link
          use:active={{ path: "/brickssynthese/" }}>Bricks</a
        >
      </div>
    </li>
    <!-- ============ . INFO ============== -->
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="/#"
        role="button"
        aria-expanded="false">Infos</a
      >
      <div class="dropdown-menu">
        <a
          class="nav-link"
          href="/buttons"
          use:link
          use:active={{ path: "/buttons/" }}>Menu boutons</a
        >
        <a
          class="nav-link"
          href="/graphedf"
          use:link
          use:active={{ path: "/graphedf/" }}>Graph EDF</a
        >
        <a
          class="nav-link"
          href="/graphtxfronciere"
          use:link
          use:active={{ path: "/graphtxfronciere/" }}>Gr Tx Froncière</a
        >
        <a
          class="nav-link"
          href="/bank"
          use:link
          use:active={{ path: "/bank/" }}>Gr. Bank</a
        >
        <a
          class="nav-link"
          href="/graphbybenef"
          use:link
          use:active={{ path: "/graphbybenef/" }}>Graph by benef.</a
        >
        <a
          class="nav-link"
          href="/restau"
          use:link
          use:active={{ path: "/restau/" }}>Restaurants</a
        >
        <a
          class="nav-link"
          href="/recettes"
          use:link
          use:active={{ path: "/recettes/" }}>recettes</a
        >
        <a
          class="nav-link"
          href="/photo"
          use:link
          use:active={{ path: "/photo/" }}>recettes photos</a
        >
        <a
          class="nav-link"
          href="/piscine"
          use:link
          use:active={{ path: "/piscine/" }}>piscine</a
        >
        <a
          class="nav-link"
          href="/cocktail"
          use:link
          use:active={{ path: "/cocktail/" }}>Cocktails</a
        >
        <a
          class="nav-link"
          href="/chrono"
          use:link
          use:active={{ path: "/chrono/" }}>Chrono</a
        >
        <a
          class="nav-link"
          href="/films"
          use:link
          use:active={{ path: "/films/" }}>films</a
        >
        <a
          class="nav-link"
          href="/test"
          use:link
          use:active={{ path: "/test/" }}>test</a
        >
        <a
          class="nav-link"
          href="/testcard"
          use:link
          use:active={{ path: "/testcard/" }}>testcard</a
        >
      </div>
    </li>
  </ul>
</div>

<style>
  a {
    color: rgb(28, 154, 245);
  }
</style>
